import React, { useMemo, useEffect, useState, useRef, useCallback } from 'react'
import { connect } from 'react-redux'

import CapacityTeamUser from './capacity-team-user'
import Loader from 'components/loader/loader'

import {
    getCapacity
} from 'state/actions'

import { 
	getCurrentAccount,
} from 'state/selectors'

import { 
	doSort
} from 'utils'

const CapacityTeam = ({
    team,
    startMoment,
    endMoment,
    allUsers,
    allTasks,
    allTeams,
    allProjects,
    onlineUsers,
    getCapacity,
    currentAccount
}) => {
    const teamUsers = useMemo(() => {
        let response = team.userIds.map(userId => {
            return allUsers[userId]
        }).filter(Boolean)

        return doSort(response, 'alpha', 'first_name')
    }, [allUsers, team])

    const allColumnsRef = useRef([])

    const [loading, setLoading] = useState(true)

    const taskUpdateCallback = useCallback(() => {
        getCapacity(team.id)
    }, [])

    useEffect(() => {
        getCapacity(team.id, columns => {
            allColumnsRef.current = columns
            setLoading(false)
        })
    }, [])

    return (
        <div className={`capacity-teams ${ loading ? 'loading' : ''}`}>
            { loading ?
                <Loader visible={true} />
            : null }
            <ul>
                {teamUsers.map((user, index) => {
                    const isOnline = onlineUsers.find(onlineUser => {
                        return user.id === onlineUser.id
                    })

                    return (
                        <CapacityTeamUser
                            user={user}
                            isOnline={isOnline}
                            key={user.id}
                            startMoment={startMoment}
                            endMoment={endMoment}
                            allTasks={allTasks}
                            allColumns={allColumnsRef.current}
                            allTeams={allTeams}
                            allProjects={allProjects}
                            allUsers={allUsers}
                            currentAccount={currentAccount}
                            zIndex={teamUsers.length - index}
                            taskUpdateCallback={taskUpdateCallback}
                        />
                    )
                })}
            </ul>

        </div>
    )
}

const mapStateToProps = state => {
    return {
        onlineUsers: state.account.onlineUsers,
        allUsers: state.account.entities.users,
        allTasks: state.account.entities.tasks,
        allTeams: state.account.entities.teams,
        allProjects: state.account.entities.projects,
		currentAccount: getCurrentAccount(state)
    }
}

export default connect(mapStateToProps, {
    getCapacity
})(CapacityTeam)


// WEBPACK FOOTER //
// ./src/sections/planning/capacity-team.jsx